import React, { useEffect, useState } from "react";
import useNetflixSearch from "../hooks/useTmdbSearch";
import requests from "../services/requests";
import "./Banner.css";
import { IoPlaySharp } from "react-icons/io5";
import { AiOutlineInfoCircle } from "react-icons/ai";

function Banner() {
  const movies = useNetflixSearch(requests.fetchNetflixOriginals, false);
  const randomMovie = movies[Math.floor(Math.random() * movies.length)];
  const baseUrl =
    "https://image.tmdb.org/t/p/original/" + randomMovie?.backdrop_path;
  console.log(baseUrl);

  const truncate = (string, maxLength) =>
    string?.length > maxLength ? `${string.substring(0, maxLength)}…` : string;
  return (
    <header
      className="banner"
      style={{
        backgroundSize: "cover",
        backgroundImage: `url(${baseUrl})`,
      }}
    >
      {/* <div className="banner__fadeTop"></div> */}

      <div className="banner__content">
        <h1 className="banner__title">
          {randomMovie?.title ||
            randomMovie?.name ||
            randomMovie?.original_name}
        </h1>

        <h1 className="banner__description">
          {truncate(randomMovie?.overview, 150)}
        </h1>
        <div className="banner_buttons">
          <button
            style={{
              color: "black",
            }}
            className="banner_button"
          >
            <IoPlaySharp size="1.2rem" style={{ paddingRight: 5 }} />
            Play
          </button>
          <button
            style={{
              marginLeft: 10,
              backgroundColor: "rgba(109, 109, 110, 0.7)",
              color: "white",
            }}
            className="banner_button"
          >
            <AiOutlineInfoCircle size="1.2rem" style={{ paddingRight: 5 }} />
            More Info
          </button>
        </div>
      </div>

      <div className="banner__fadeBottom"></div>
    </header>
  );
}

export default Banner;
